<template>
  <v-card>
    <v-card-title class="d-flex align-center">Companies</v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search by name"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            v-model="selectedLanguage"
            :items="languages"
            item-text="name"
            item-value="id"
            label="Select by language"
            clearable
            class="ml-4"
            @change="debounceFetching"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-data-table
      :headers="headers"
      :items="companies"
      class="elevation-1"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalAmount"
      :footer-props="{
        'items-per-page-options': $options.DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      }"
    >
      <template v-slot:[`item.name`]="{ item }">
        <router-link :to="{ name: 'Company', params: { id: item.id } }">
          <span v-if="item.name && item.name.length > truncateLength">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  truncateText(item.name, truncateLength)
                }}</span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </span>
          <span v-else>
            {{ item.name }}
          </span>
        </router-link>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:[`item.language`]="{ item }">
        <span v-if="item.language">
          {{ LANGUAGES.find((language) => language.id === item.language).name }}
        </span>
        <span v-else>
          {{ item.language }}
        </span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { API } from "../../api";
import { formatDate, truncateText } from "../../helpers";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS, LANGUAGES } from "../../constants";

export default {
  name: "CompaniesTable",
  DEFAULT_ITEMS_PER_PAGE_OPTIONS,
  data() {
    return {
      LANGUAGES,
      formatDate,
      truncateText,
      truncateLength: 40,
      timerId: null,
      loading: true,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          width: "300",
        },
        {
          text: "Created at",
          sortable: true,
          value: "createdAt",
        },
        {
          text: "Language",
          sortable: false,
          value: "language",
        },
      ],
      companies: [],
      totalAmount: 0,
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["createdAt"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      },
      selectedLanguage: null,
      languages: LANGUAGES,
    };
  },
  computed: {
    searchQuery() {
      const trimmedSearch = this.search.trim();
      return trimmedSearch === "" ? null : trimmedSearch;
    },
  },
  watch: {
    search: {
      handler: "debounceFetching",
    },
    options: {
      handler: "debounceFetching",
      deep: true,
    },
  },
  methods: {
    debounceFetching() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }

      this.timerId = setTimeout(() => {
        this.getCompanies();
      }, 500);
    },
    async getCompanies() {
      this.loading = true;
      try {
        const companies = await API.getCompanies({
          sortBy: this.options.sortBy[0],
          order: this.options.sortDesc[0] ? "desc" : "asc",
          page: this.options.page,
          pageSize:
            this.options.itemsPerPage === -1 ? 0 : this.options.itemsPerPage,
          query: this.searchQuery,
          language: this.selectedLanguage,
        });
        this.companies = companies.data;
        this.totalAmount = companies.count;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
